import { render, staticRenderFns } from "./FormItemDate.vue?vue&type=template&id=46a4759c"
import script from "./FormItemDate.vue?vue&type=script&lang=ts"
export * from "./FormItemDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports